import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
import { Dropdown } from "./Dropdown.js";
import { Button } from "./Button.js";
const SelectContext = createContext({
  value: "",
  onChange: () => {
  }
  // eslint-disable-line @typescript-eslint/no-empty-function
});
function Select({
  children,
  isDisabled,
  onChange,
  value,
  label,
  icon,
  "aria-labelledby": ariaLabelledBy,
  "aria-label": ariaLabel,
  ...props
}) {
  const ctxValue = useMemo(() => {
    return {
      value,
      onChange
    };
  }, [onChange, value]);
  return /* @__PURE__ */ jsx(SelectContext.Provider, {
    value: ctxValue,
    children: /* @__PURE__ */ jsx(Dropdown, {
      trigger: ({
        isOpen,
        ...triggerProps
      }) => /* @__PURE__ */ jsx(Button, {
        icon,
        isPressed: isOpen,
        rightIcon: /* @__PURE__ */ jsx(Dropdown.Arrow, {}),
        isFullWidth: true,
        isDisabled,
        role: "combobox",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        ...triggerProps,
        "aria-haspopup": "listbox",
        children: /* @__PURE__ */ jsx(Dropdown.SelectButtonText, {
          children: label
        })
      }),
      position: "bottom",
      role: "listbox",
      ...props,
      children
    })
  });
}
Select.Item = Item;
Select.SectionTitle = Dropdown.SectionTitle;
Select.Divider = Dropdown.Divider;
Select.SearchInput = Dropdown.SearchInput;
Select.Text = Dropdown.Text;
function Item({
  icon,
  children,
  isDisabled,
  value
}) {
  const context = useContext(SelectContext);
  return /* @__PURE__ */ jsx(Dropdown.Item, {
    isChecked: value === context.value,
    role: "option",
    icon,
    isDisabled,
    onClick: () => {
      context.onChange(value);
    },
    children
  });
}
export {
  Select
};
//# sourceMappingURL=Select.js.map
